/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const VLINDER_LOGO = require("./res/images/vLogo.png");
export const KLEFKI_LOGO = require("./res/images/klefki.png");

export const DUMMY_IMAGE = require("./res/images/300-300.png");
export const ORDINARY_DAY_IMAGE = require("./res/images/ordinary-day.png");
export const VLINDER_IMAGE = require("./res/images/vlinder-logo.png");

export const GOLD_ICON = require('./res/images/gold.png');
export const PLATINUM_ICON = require('./res/images/platinum-1.png');
export const DIAMOND_ICON = require('./res/images/diamond.png');
export const EMPTY_IMAGE = require("./res/images/empty.png");
export const MS_DHONI = require('./res/images/ms-dhoni.jpg');
export const N0_IMAGE = require('./res/images/no-image.jpeg');

export const CREATE_ASSET  =  require('./res/images/create-asset.png');
export const MINT_ASSET  =  require('./res/images/mint-asset.png');
export const LIST_ASSET  =  require('./res/images/list-asset.png');


export const SOUND = require('./res/images/sound.png');

export const IMAGES = [
    VLINDER_LOGO,
    KLEFKI_LOGO,
    DUMMY_IMAGE,
    ORDINARY_DAY_IMAGE,
    VLINDER_IMAGE,
    GOLD_ICON,
    PLATINUM_ICON,
    DIAMOND_ICON,
    EMPTY_IMAGE,
    MS_DHONI,
    N0_IMAGE,
    SOUND,
    CREATE_ASSET,
    MINT_ASSET

];
